import React from "react";
import { Tooltip } from "flowbite-react";

export default function Skills() {
  return (
    /* eslint-disable */
    <div
      id="skills"
      className="items-center px-6 py-8 bg-mesanfaz-gray-2 sm:px-8 md:px-12 md:py-12"
    >
      <div className="text-4xl font-black sm:text-5xl md:text-6xl lg:text-4xl xl:text-5xl 2xl:text-6xl">
        skills
      </div>
      <div className="grid gap-4 pt-12 max-sm:grid-cols-4 sm:grid-cols-7 md:grid-cols-8 xl:grid-cols-10 2xl:grid-cols-12">
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="GO" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-go.svg"}
              alt="GO"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Javascript" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-js.svg"}
              alt="Javascript"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Typescript" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-ts.svg"}
              alt="Typescript"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Fiber Framework" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-fiber.svg"}
              alt="Fiber Framework"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Gin Framework" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-gin.svg"}
              alt="Gin Framework"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Echo Framework" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-echo.svg"}
              alt="Echo Framework"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="ExpressJS Framework" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-express.svg"}
              alt="ExpressJS Framework"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="NestJS Framework" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-nest.svg"}
              alt="NestJS Framework"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="ReactJS and React Native" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-react.svg"}
              alt="ReactJS and React Native"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="MongooseJS ORM" animation="duration-500">
            <img
              className="w-8 h-8"
              src={process.env.PUBLIC_URL + "/svg-mongoose.svg"}
              alt="MongooseJS ORM"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="MongoDB Database" animation="duration-500">
            <img
              className="w-8 h-8"
              src={process.env.PUBLIC_URL + "/svg-mongo.svg"}
              alt="MongoDB Database"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="GO ORM" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-gorm.svg"}
              alt="GO ORM"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="SequelizeJS ORM" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-sequelize.svg"}
              alt="SequelizeJS ORM"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Type ORM" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-typeorm.svg"}
              alt="Type ORM"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="MySQL Database" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-mysql.svg"}
              alt="MySQL Database"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="PostgreSQL Database" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-postgresql.svg"}
              alt="PostgreSQL Database"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="AWS S3" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-aws.svg"}
              alt="AWS S3"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="MINIO" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-minio.svg"}
              alt="MINIO"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Tailwind CSS" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-tailwindcss.svg"}
              alt="Tailwind CSS"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Bootstrap CSS" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-bootstrap.svg"}
              alt="Bootstrap CSS"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Sass CSS" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-sass.svg"}
              alt="Sass CSS"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Docker" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-docker.svg"}
              alt="Docker"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="MochaJS Test" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-mocha.svg"}
              alt="MochaJS Test"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="ChaiJS Test" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-chai.svg"}
              alt="ChaiJS Test"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="JestJS Test" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-jest.svg"}
              alt="JestJS Test"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="GIT" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-git.svg"}
              alt="GIT"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Socket" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-socket.svg"}
              alt="Socket"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="PHP" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-php.svg"}
              alt="PHP"
            />
          </Tooltip>
        </div>
        <div className="flex items-center justify-center h-16 border rounded-lg border-mesanfaz-black">
          <Tooltip content="Laravel Framework" animation="duration-500">
            <img
              className="w-12 h-12"
              src={process.env.PUBLIC_URL + "/svg-laravel.svg"}
              alt="Laravel Framework"
            />
          </Tooltip>
        </div>
      </div>
    </div>
  );
}
